import moment from 'moment';

export default {
  methods: {
    formatBooleanValue({ value }) {
      return value ? 'Ja' : 'Nein';
    },
    formatDegree({ value }) {
      const degree = this.filters.e_degree.options.find((obj) => obj.id === value);
      return degree ? degree.short : '---';
    },
    formatStudyType({ value }) {
      const studyType = this.filters.e_studyType.options.find((obj) => obj.id === value);
      return studyType ? studyType.short : '---';
    },
    formatSpecializations({ value }) {
      const labels = value.map((elem) => {
        return this.filters.e_specializations.options.find((obj) => obj.id === elem).name;
      });
      return labels.length ? labels.join(', ') : '---';
    },
    formatWithDefaultValue({ value }) {
      return null !== value ? value : '---';
    },
    formatDate({ value }) {
      return null !== value ? moment(value).format('DD.MM.YYYY') : '---';
    },
    formatStudentId({ value }) {
      return (value >= 100000) ? value : 'J' + value;
    },
    formatCitizenship({ value }) {
      const labels = value.map((elem) => {
        return this.filters.s_citizenships.options.find((obj) => obj.id === elem).name;
      });
      return labels.length ? labels.join(', ') : '---';
    },
    formatInstitute({ value }) {
      if (value === 'mhs') return 'MHS';
      if (value === 'ifm') return 'IFM';
    },
    formatMinutes({ value }) {
      if (value == null) return '';

      const h = Math.trunc(value / 60);
      const m = Math.abs(value % 60);

      return h.toString() + ':' + (m < 10 ? '0' : '') + m.toString();
    },
  },
};
